// Builds the JSON payload for create / update stock requests.
export const buildStockPayload = (values) => {
  const payload = {};

  const set = (key, value) => {
    if (value !== undefined && value !== null && value !== "") {
      payload[key] = value;
    }
  };

  set("symbol", values.symbol);
  set("name", values.name);
  set("currency", values.currency?.value);
  set("current_price", values.current_price);
  set("available_volume", values.available_volume);
  set("percent_change", values.percent_change);
  set("trend", values.trend?.value);
  set("description", values.description);
  set("sector", values.sector);
  set("min_volume", values.min_volume);
  // set("min_price", values.min_price);
  // set("max_price", values.max_price);
  set("logo_url", values.logo_url);
  // is_active / is_shariah_compliant are boolean selects (value 1 / 0)
  payload.is_active = values.is_active?.value ?? 1;
  payload.is_shariah_compliant = values.is_shariah_compliant?.value ?? 1;

  return payload;
};

// Builds the multipart payload for create / update stock requests.
export const buildStockFormData = (values, logo) => {
  const formData = new FormData();

  const append = (key, value) => {
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, value);
    }
  };

  append("symbol", values.symbol);
  append("name", values.name);
  append("currency", values.currency?.value);
  append("current_price", values.current_price);
  append("available_volume", values.available_volume);
  append("percent_change", values.percent_change);
  append("trend", values.trend?.value);
  append("description", values.description);
  append("sector", values.sector);
  append("min_volume", values.min_volume);
  // append("min_price", values.min_price);
  // append("max_price", values.max_price);
  append("logo_url", values.logo_url);
  // is_active / is_shariah_compliant are boolean selects (value 1 / 0)
  formData.append("is_active", values.is_active?.value ?? 1);
  formData.append(
    "is_shariah_compliant",
    values.is_shariah_compliant?.value ?? 1,
  );

  if (logo) {
    formData.append("logo_file", logo);
  }

  return formData;
};
